import React from 'react'
import { Link } from 'gatsby'
import Layout from '../components/layout'
import SEO from '../components/seo'

const NotFoundPage = () => (
  <Layout>
    <SEO
      title="404: Not found"
      description="You have reached a page that does not exist."
      canonical="https://www.longmakeup.com/404"
    />
    <div
      className="w3-container w3-center w3-padding"
      style={{ margin: 'var(--center)', maxWidth: 'var(--width)' }}
    >
      <h1>NOT FOUND</h1>
      <p>You have reached a page that does not exist.</p>
      <Link className="w3-btn w3-black" to="/">
        Back to home
      </Link>
    </div>
  </Layout>
)

export default NotFoundPage
